import Cookies from 'js-cookie';

const ACCESS_TOKEN_COOKIE = 'accessToken';
const REFRESH_TOKEN_COOKIE = 'refreshToken';
const ACCESS_TOKEN_EXPIRES_DAYS = 15 / (24 * 60);
const REFRESH_TOKEN_EXPIRES_DAYS = 8 / 24;
const LAST_ACTIVITY_COOKIE = 'lastActivityTime';

let userContextMemory = null;

export const setUserCookies = (userData) => {
  // Keep user details only in memory; source of truth is backend /auth/context cache.
  Cookies.remove('user');
  userContextMemory = userData || null;
};

export const setAuthCookies = ({ accessToken, refreshToken }) => {
  if (accessToken) {
    Cookies.set(ACCESS_TOKEN_COOKIE, accessToken, { expires: ACCESS_TOKEN_EXPIRES_DAYS, path: '/' });
  }
  if (refreshToken) {
    Cookies.set(REFRESH_TOKEN_COOKIE, refreshToken, { expires: REFRESH_TOKEN_EXPIRES_DAYS, path: '/' });
  }
};

export const getAccessTokenCookie = () => Cookies.get(ACCESS_TOKEN_COOKIE) || null;

export const getRefreshTokenCookie = () => Cookies.get(REFRESH_TOKEN_COOKIE) || null;

export const removeAuthCookies = () => {
  Cookies.remove(ACCESS_TOKEN_COOKIE, { path: '/' });
  Cookies.remove(REFRESH_TOKEN_COOKIE, { path: '/' });
};

export const setLastActivityCookie = (timestamp) => {
  Cookies.set(LAST_ACTIVITY_COOKIE, String(timestamp), { expires: ACCESS_TOKEN_EXPIRES_DAYS, path: '/' });
};

export const getLastActivityCookie = () => Cookies.get(LAST_ACTIVITY_COOKIE) || null;

export const removeLastActivityCookie = () => {
  Cookies.remove(LAST_ACTIVITY_COOKIE, { path: '/' });
};

export const installLegacyTokenStorageBridge = () => {
  if (typeof window === 'undefined' || window.__tokenStorageBridgeInstalled) {
    return;
  }

  const originalGetItem = window.localStorage.getItem.bind(window.localStorage);
  const originalSetItem = window.localStorage.setItem.bind(window.localStorage);
  const originalRemoveItem = window.localStorage.removeItem.bind(window.localStorage);

  window.localStorage.clear();

  window.localStorage.getItem = (key) => {
    if (key === 'accessToken') return getAccessTokenCookie();
    if (key === 'refreshToken') return getRefreshTokenCookie();
    return null;
  };

  window.localStorage.setItem = (key, value) => {
    if (key === 'accessToken') {
      setAuthCookies({ accessToken: value });
      return;
    }
    if (key === 'refreshToken') {
      setAuthCookies({ refreshToken: value });
      return;
    }
    // Block all other localStorage writes.
  };

  window.localStorage.removeItem = (key) => {
    if (key === 'accessToken' || key === 'refreshToken') {
      if (key === 'accessToken') {
        Cookies.remove(ACCESS_TOKEN_COOKIE);
      } else {
        Cookies.remove(REFRESH_TOKEN_COOKIE);
      }
      return;
    }
    // Ignore non-token removals because the app no longer stores data in localStorage.
  };

  window.__tokenStorageBridgeInstalled = true;
};

export const getUserFromCookies = () => {
  if (!userContextMemory) return null;
  return { data: userContextMemory };
};

export const removeUserCookies = () => {
  Cookies.remove('user');
  userContextMemory = null;
};
